/* eslint-disable no-unreachable */
import { Duck, DuckSelector, createSelector, createAction } from '@atc/modular-redux';
export default function paginationDuckCreator(_temp) {
  let {
    namespace = '',
    store = 'pagination',
    storePath,
    initialState,
    ...rest
  } = _temp === void 0 ? {} : _temp;
  return new Duck({
    ...rest,
    namespace,
    store,
    storePath,
    consts: {},
    types: ['DERIVE_CURRENT_PAGE', 'RESET_PAGINATION', 'SET_NUM_RECORDS', 'SET_CURRENT_PAGE'],
    initialState: {
      firstRecord: 0,
      numRecords: 25,
      currentPage: 1,
      ...initialState
    },
    reducer: (state, action, _ref) => {
      let {
        types,
        initialState: _initialState
      } = _ref;
      switch (action.type) {
        case types.DERIVE_CURRENT_PAGE:
          {
            let newState = {
              ...state
            };

            // Default first record and numRecords to initial state
            let {
              firstRecord = _initialState.firstRecord,
              numRecords = _initialState.numRecords
            } = action.payload;
            firstRecord = parseInt(firstRecord, 10);
            numRecords = parseInt(numRecords, 10);
            newState = {
              firstRecord,
              numRecords,
              currentPage: Math.floor(firstRecord / numRecords) + 1
            };
            return newState;
          }
        case types.RESET_PAGINATION:
          {
            return {
              ..._initialState,
              numRecords: state.numRecords
            };
            break;
          }
        case types.SET_NUM_RECORDS:
          {
            const numRecords = parseInt(action.payload, 10);
            return {
              ...state,
              numRecords: parseInt(numRecords, 10),
              currentPage: Math.floor(state.firstRecord / numRecords) + 1
            };
            break;
          }
        case types.SET_CURRENT_PAGE:
          {
            const currentPage = parseInt(action.payload, 10);
            return {
              ...state,
              currentPage,
              firstRecord: Math.floor(state.numRecords * (currentPage - 1))
            };
            break;
          }
        default:
          return state;
      }
    },
    selectors: duck => ({
      getState: new DuckSelector(selectors => createSelector(selectors.getDuckState, localState => localState))
    }),
    creators: _ref2 => {
      let {
        types
      } = _ref2;
      return {
        deriveCurrentPage: createAction(types.DERIVE_CURRENT_PAGE),
        resetPagination: createAction(types.RESET_PAGINATION),
        setNumRecords: createAction(types.SET_NUM_RECORDS),
        setCurrentPage: createAction(types.SET_CURRENT_PAGE)
      };
    }
  });
}